var premiumarticleinfo = [
   
    //     {
    //     id: 14,
    //     title: "What is the cost of removing coal generation?",
    //     date: "June 2024",
    //     description: "We have calculated the average cost of generation under a plausible scenario as coal is replaced by renewable energy.... ",
    //     coverImg: "solarfarm.jpg",
    //     page: "/Premarticle8"
    // }, 
    {
        id: 21,
        title: "WEM Monthly Review",
        date: "Register to read",
        description: "Insights into the Western Australian Wholesale Electricity Market.",
        coverImg: "FrontPage.png",
        page: "Premarticle15"
    },  
   
    {
        id: 20,
        title: "The challenges with estimating returns for renewable energy projects",
        date: "July 2025, Register to read",
        description: "We explain why the returns from some renewable energy projects are less than might be expected ...",
        coverImg: "solarcells.jpg",
        page: "Premarticle16"
    },   


    {
        id: 19,
        title: "How much would nuclear energy add to the cost of generation?",
        date: "September 2024, Register to read",
        description: "We have costed the transition to a low-emissions electricity grid under alternative scenarios ...  ",
        coverImg: "lamp.jpg",
        page: "Premarticle13"
    },    

    {
        id: 18,
        title: "What is driving price volatility in the WEM?",
        date: "August 2024, Register to read",
        description: "The new market design has increased volatility, but a change in bidding behaviour has also increased volatility ...  ",
        coverImg: "MagdaEhlers.jpg",
        page: "Premarticle12"
    },    

    {
        id: 17,
        title: "Emission reductions and reliability at risk under current market settings",
        date: "June 2024, Register to read",
        description: "If current trends in the market continue, carbon emissions in the WEM will remain at current levels for an extended period and reliability may not be maintained ... ",
        coverImg: "solarfarm.jpg",
        page: "Premarticle11"
    }, 

    {
        id: 16,
        title: "Gas generation doesn't need to increase",
        date: "May 2024",
        description: "There is a plausible scenario where the exit of coal generation doesn't result in an increase in gas generation ... ",
        coverImg: "lighter.jpg",
        page: "/Premarticle10"
    }, 


    {
        id: 15,
        title: "Thermal generators benefiting from higher prices",
        date: "March 2024",
        description: "A substantial increase in the price of energy in the WEM has boosted the wholesale value of coal and gas generation ... ",
        coverImg: "gasburner.jpg",
        page: "/Premarticle9"
    }, 
    
    
    {
        id: 6,
        title: "Why is the new market producing volatile prices?",
        date: "March 2024",
        description: "Balancing prices have become more volatile since the new market commenced in October 2023...",
        coverImg: "lighteg.jpg",
        page: "/Premarticle6"
    },
    
    {
        id: 5,
        title: "How did the market cope this summer?",
        date: "March 2024",
        description: "We review how the market coped with the hot summer...",
        coverImg: "transmissioneg.jpg",
        page: "/Premarticle5"
    },
    
    {
        id: 1,
        title: "Blackout risk heading into the summer peak",
        date: "January 2024",
        description: "We ran our model to identify the risk of a blackout over the 2023/24 summer....",
        coverImg: "blackout.jpg",
        page: "/Premarticle1"
    },

    //{
    //    id: 2,
    //    title: "Carbon emissions tracker",
    //    date: "January 2024",
    //    description: "We forecast what might happen to carbon emissions over the next ten years ....",
    //    coverImg: "Carbonhistory.jpeg",
    //    page: "/Premarticle2"
    //},

    {
        id: 3,
        title: "Our views on operational demand",
        date: "January 2024",
        description: "Our ten year forecast of operational demand, including our assumptions of rooftop PV generation and electric vehicle uptake.....",
        coverImg: "sunset.jpg",
        page: "/Premarticle3"
    },

    // {
    //     id: 4,
    //     title: "Standard products",
    //     date: "January 2024",
    //     description: "We review Synergy’s standard products prices in order to understand the assumptions that underpin the forecasts and compared their forecasts to ours...",
    //     coverImg: "windmills2.jpg",
    //     page: "/Premarticle4"
    // },

    {
        id: 7,
        title: "Policy priorities for the WEM",
        date: "February 2023",
        description: "Our review of the ERA's report on the effectieness of the WEM .....",
        coverImg: "elec.jpg",
        page: "/Premarticle7"
    },
]

export default premiumarticleinfo